function extractHost(input) {
  if (!input) return null;
  try {
    // Add default protocol if missing
    if (!/^https?:\/\//i.test(input)) {
      input = 'http://' + input;
    }

    const url = new URL(input);
    let hostname = url.hostname;

    // Remove 'www.' if present
    if (hostname.startsWith('www.')) {
      hostname = hostname.slice(4);
    }

    return hostname;
  } catch (e) {
    console.error('Invalid input URL:', input);
    return null;
  }
}

export default extractHost;
